/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BigNumberish,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PaperPotMint, PaperPotMintInterface } from "../PaperPotMint";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "PAPER_POT_ADDRESS_",
        type: "address",
      },
      {
        internalType: "address",
        name: "WETH_ADDRESS_",
        type: "address",
      },
      {
        internalType: "address",
        name: "fundsRecipient_",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "mintStartDate_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "mintEndDate_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxSupply_",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "isAdmin",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "p",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "pauseMinting",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        internalType: "bool",
        name: "add",
        type: "bool",
      },
    ],
    name: "setAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpauseMinting",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mintEndDate_",
        type: "uint256",
      },
    ],
    name: "updateMintEndDate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

type PaperPotMintConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: PaperPotMintConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class PaperPotMint__factory extends ContractFactory {
  constructor(...args: PaperPotMintConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    PAPER_POT_ADDRESS_: string,
    WETH_ADDRESS_: string,
    fundsRecipient_: string,
    mintStartDate_: BigNumberish,
    mintEndDate_: BigNumberish,
    maxSupply_: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<PaperPotMint> {
    return super.deploy(
      PAPER_POT_ADDRESS_,
      WETH_ADDRESS_,
      fundsRecipient_,
      mintStartDate_,
      mintEndDate_,
      maxSupply_,
      overrides || {}
    ) as Promise<PaperPotMint>;
  }
  getDeployTransaction(
    PAPER_POT_ADDRESS_: string,
    WETH_ADDRESS_: string,
    fundsRecipient_: string,
    mintStartDate_: BigNumberish,
    mintEndDate_: BigNumberish,
    maxSupply_: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      PAPER_POT_ADDRESS_,
      WETH_ADDRESS_,
      fundsRecipient_,
      mintStartDate_,
      mintEndDate_,
      maxSupply_,
      overrides || {}
    );
  }
  attach(address: string): PaperPotMint {
    return super.attach(address) as PaperPotMint;
  }
  connect(signer: Signer): PaperPotMint__factory {
    return super.connect(signer) as PaperPotMint__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PaperPotMintInterface {
    return new utils.Interface(_abi) as PaperPotMintInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PaperPotMint {
    return new Contract(address, _abi, signerOrProvider) as PaperPotMint;
  }
}
